import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  providerCheckoutFieldsService,
  ProviderCheckoutFieldsRequestError,
} from '@/services/provider/checkout-fields.service';
import type {
  ProviderCheckoutFieldsSettings,
  UpdateProviderCheckoutFieldsInput,
} from '@/types/provider-checkout-fields';

export const providerCheckoutFieldsKeys = {
  all: ['provider', 'settings', 'checkout-fields'] as const,
  detail: (locale?: string) => [...providerCheckoutFieldsKeys.all, 'detail', locale ?? ''] as const,
};

export function useProviderCheckoutFieldsSettings(enabled = true, locale?: string) {
  return useQuery<ProviderCheckoutFieldsSettings, ProviderCheckoutFieldsRequestError>({
    queryKey: providerCheckoutFieldsKeys.detail(locale),
    queryFn: () => providerCheckoutFieldsService.getSettings(locale),
    enabled,
  });
}

export function useUpdateProviderCheckoutFieldsSettings() {
  const queryClient = useQueryClient();

  return useMutation<
    ProviderCheckoutFieldsSettings,
    ProviderCheckoutFieldsRequestError,
    UpdateProviderCheckoutFieldsInput
  >({
    mutationFn: (input) => providerCheckoutFieldsService.updateSettings(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: providerCheckoutFieldsKeys.all });
    },
  });
}
